import axios from "axios"

export default function requestResetPassword({ email }) {
    return new Promise((resolve, reject) => {
        axios.post("account/public/api/v1/reset-password", { email })
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}